import {
  Checklist,
  Code,
  DataObject,
  FormatBold,
  FormatItalic,
  FormatListBulleted,
  FormatListNumbered,
  FormatQuote,
  FormatStrikethrough,
  Link,
  Title,
} from '@mui/icons-material';

import {
  insertCodeBlock,
  insertLink,
  TextEdit,
  TextSelection,
  toggleLines,
  wrapSelection,
} from './markdownEdits';

export type MarkdownAction = {
  label: string;
  icon: React.ReactNode;
  /** `event.code` с Cmd/Ctrl — не зависит от раскладки */
  hotkey?: string;
  edit: (selection: TextSelection) => TextEdit;
};

/** Кнопки панели по группам: текст, блоки, вставки. Разметка — YFM, как в Яндекс Трекере */
export const MARKDOWN_ACTION_GROUPS: MarkdownAction[][] = [
  [
    {
      label: 'Жирный',
      icon: <FormatBold fontSize="small" />,
      hotkey: 'KeyB',
      edit: (selection) => wrapSelection({ selection, marker: '**' }),
    },
    {
      label: 'Курсив',
      icon: <FormatItalic fontSize="small" />,
      hotkey: 'KeyI',
      edit: (selection) => wrapSelection({ selection, marker: '_' }),
    },
    {
      label: 'Зачёркнутый',
      icon: <FormatStrikethrough fontSize="small" />,
      hotkey: 'KeyS',
      edit: (selection) => wrapSelection({ selection, marker: '~~' }),
    },
    {
      label: 'Код',
      icon: <Code fontSize="small" />,
      hotkey: 'KeyE',
      edit: (selection) => wrapSelection({ selection, marker: '`' }),
    },
  ],
  [
    {
      label: 'Заголовок',
      icon: <Title fontSize="small" />,
      edit: (selection) => toggleLines({ selection, format: 'heading' }),
    },
    {
      label: 'Маркированный список',
      icon: <FormatListBulleted fontSize="small" />,
      edit: (selection) => toggleLines({ selection, format: 'bullet' }),
    },
    {
      label: 'Нумерованный список',
      icon: <FormatListNumbered fontSize="small" />,
      edit: (selection) => toggleLines({ selection, format: 'numbered' }),
    },
    {
      label: 'Чек-лист',
      icon: <Checklist fontSize="small" />,
      edit: (selection) => toggleLines({ selection, format: 'check' }),
    },
    {
      label: 'Цитата',
      icon: <FormatQuote fontSize="small" />,
      edit: (selection) => toggleLines({ selection, format: 'quote' }),
    },
  ],
  [
    { label: 'Ссылка', icon: <Link fontSize="small" />, hotkey: 'KeyK', edit: insertLink },
    { label: 'Блок кода', icon: <DataObject fontSize="small" />, edit: insertCodeBlock },
  ],
];

export const MARKDOWN_ACTIONS = MARKDOWN_ACTION_GROUPS.flat();
